export default function TechEducationSection() {
  const programs = [
    {
      icon: 'ri-scissors-line',
      title: '기초 봉제 교육',
      duration: '3개월 과정',
      description: '재봉틀 사용법부터 기본 봉제 기술까지, 처음 시작하는 분들을 위한 체계적인 교육 프로그램입니다.',
      topics: ['재봉틀 기초', '직선 봉제', '곡선 처리', '기본 마감'],
    },
    {
      icon: 'ri-pencil-ruler-2-line',
      title: '패턴 제작 교육',
      duration: '4개월 과정',
      description: '의복 구조를 이해하고 패턴을 제작하는 전문 기술을 배웁니다.',
      topics: ['패턴 이론', '실측 제도', '그레이딩', '샘플 제작'],
    },
    {
      icon: 'ri-tools-line',
      title: '산업용 봉제 교육',
      duration: '6개월 과정',
      description: '산업 현장에서 필요한 고급 봉제 기술과 특수 기법을 습득합니다.',
      topics: ['산업용 재봉틀', '특수 봉제', '품질 관리', '생산 공정'],
    },
  ];

  return (
    <section className="py-32 px-6 bg-white">
      <div className="max-w-7xl mx-auto">
        <div className="grid lg:grid-cols-2 gap-16 items-center mb-24">
          <div>
            <h2 className="text-5xl font-bold text-stone-800 mb-8 leading-tight" style={{ fontFamily: "'Cormorant Garamond', serif" }}>
              기술 교육
            </h2>
            <div className="w-24 h-1 bg-emerald-600 mb-8"></div>
            <p className="text-xl text-stone-600 leading-relaxed mb-8" style={{ fontFamily: "'Noto Sans KR', sans-serif" }}>
              봉제 기술 전수
            </p>
            <p className="text-base text-stone-600 leading-relaxed mb-6">
              Daygreen은 단순히 기술을 가르치는 것이 아니라, 한 사람의 자립을 돕는 교육을 지향합니다. 
              경험 많은 선생님들이 직접 가르치며, 실무 중심의 체계적인 커리큘럼으로 진행됩니다.
            </p>
            <div className="space-y-4">
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 flex items-center justify-center bg-emerald-600 rounded-full">
                  <i className="ri-check-line text-xl text-white"></i>
                </div>
                <span className="text-base text-stone-700 font-medium">1:1 맞춤 교육</span>
              </div>
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 flex items-center justify-center bg-emerald-600 rounded-full">
                  <i className="ri-check-line text-xl text-white"></i>
                </div>
                <span className="text-base text-stone-700 font-medium">실무 중심 커리큘럼</span>
              </div>
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 flex items-center justify-center bg-emerald-600 rounded-full">
                  <i className="ri-check-line text-xl text-white"></i>
                </div>
                <span className="text-base text-stone-700 font-medium">취업 연계 지원</span>
              </div>
            </div>
          </div>

          <div className="relative">
            <div className="relative rounded-2xl overflow-hidden shadow-2xl">
              <img
                src="https://public.readdy.ai/ai/img_res/42f9c03496c5ce3e418bd24e70bb14a2.jpg"
                alt="기술 교육"
                className="w-full h-full object-cover object-top"
              />
            </div>
            <div className="absolute -bottom-8 -right-8 w-48 h-48 bg-emerald-100 rounded-2xl -z-10"></div>
          </div>
        </div>

        <div className="grid md:grid-cols-3 gap-8">
          {programs.map((program, index) => (
            <div
              key={index}
              className="bg-stone-50 p-8 rounded-2xl hover:shadow-xl transition-all duration-300 hover:-translate-y-2 border border-stone-100"
            >
              <div className="w-16 h-16 bg-emerald-100 rounded-2xl flex items-center justify-center mb-6">
                <i className={`${program.icon} text-3xl text-emerald-700`}></i>
              </div>
              <h3 className="text-2xl font-bold text-stone-800 mb-3" style={{ fontFamily: "'Noto Sans KR', sans-serif" }}>
                {program.title}
              </h3>
              <p className="text-emerald-700 font-semibold mb-4 text-sm">
                {program.duration}
              </p>
              <p className="text-stone-600 leading-relaxed mb-6 text-sm">
                {program.description}
              </p>
              <div className="space-y-2">
                {program.topics.map((topic, idx) => (
                  <div key={idx} className="flex items-center gap-2">
                    <div className="w-1.5 h-1.5 bg-emerald-600 rounded-full"></div>
                    <span className="text-stone-700 text-sm">{topic}</span>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}